import UpdateCategoryInfo from "./UpdateCategoryInfo";

export default UpdateCategoryInfo;
